// An upload or order message stays under the sample actions until the next action replaces it.
// Errors are the only ones shown in red.
export function SoilSampleNote(props: { note: string; error: boolean }) {
  const { note, error } = props;
  return (
    <span className={`text-[11px] ${error ? "text-red-400" : "text-muted"}`}>
      {note}
    </span>
  );
}
